var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"desc"},[_c('b-container',{staticClass:"container--article"},[_c('h2',{staticClass:"desc__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('a',{staticClass:"desc__btn btn btn--square",attrs:{"href":_vm.btn.href}},[_vm._v(" "+_vm._s(_vm.btn.label)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }